import { z } from 'zod'
import { get } from './axios'
import { role } from './user/role'
import { status } from './campaign/status'
import { candidateStatus } from './candidate/candidate'

export const searchResponse = z.object({
    users: z
        .object({
            id: z.string(),
            name: z.string(),
            avatar: z.string(),
            email: z.string(),
            role,
            emailVerifiedAt: z.coerce.date().nullable(),
            blockedAt: z.coerce.date().nullable(),
            createdAt: z.coerce.date(),
            updatedAt: z.coerce.date(),
        })
        .array()
        .optional(),
    campaigns: z
        .object({
            id: z.string(),
            title: z.string(),
            status: status,
            createdAt: z.coerce.date(),
            updatedAt: z.coerce.date(),
        })
        .array()
        .optional(),
    candidates: z
        .object({
            id: z.string(),
            name: z.string(),
            phone: z.string(),
            avatar: z.string(),
            status: candidateStatus,
            campaignId: z.string(),
            campaignTitle: z.string(),
            createdAt: z.coerce.date(),
            updatedAt: z.coerce.date(),
        })
        .array()
        .optional(),
})

export type CampaignSearchResponse = NonNullable<SearchResponse['campaigns']>[0]
export type SearchResponse = z.infer<typeof searchResponse>

export const search = (query: string) => {
    return get(searchResponse, `/search/${query}`)
}
